export const endpoints = {
  municipalityUsersCount: (municipality) => {
    const params = new URLSearchParams({
      'filter[municipality]': municipality,
    });
    return `/public/users/municipality/count?${municipality && params.toString()}`;
  },
  municipalityTotalGroupsCount: (municipality) => {
    const params = new URLSearchParams({
      municipality,
    });
    return `/public/groups/municipality/count?${municipality && params.toString()}`;
  },
  postReaction: (postId) => `/public/posts/${postId}/reactions`,
  postReactions: (postId) => `/public/posts/${postId}/reactions/total`,
  deletePostReaction: (postId, reaction) =>
    `/public/posts/${postId}/reactions/${reaction}`,
  addInterestedUser: () => '/public/interested-users',
};
